import { Check } from '@fluentui/react';
import { AddIcon, SearchIcon } from '@fluentui/react-icons-northstar';
import { Button, Flex, FlexItem, ShareGenericIcon, TrashCanIcon } from '@fluentui/react-northstar';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { addFilesToMeeting, removeContent, selectAllRecommendationItems } from '../../store/Meeting/actions';
import MessageBox from '../SuccessMessage';
import styles from './index.module.scss';

const Header = ({
    successMessage,
    onAddFileClick,
    isShareVisible,
    isShareEnabled,
    onShareclick,
    isMobile
}: {
    isShareVisible?: boolean;
    isShareEnabled?: boolean;
    successMessage?: string;
    onAddFileClick: () => void;
    onShareclick?: () => void;
    isMobile?: boolean;
}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const {
        currentMeeting,
        selectedFilesForRemove,
        selectRecommendedStory,
        selectedBookmarkId,
        selectedFiles,
        adding,
        removing,
    } = useTypedSelector((state: ApplicationState) => state.meeting);
    const removeSelectedFiles = () => {
        dispatch(removeContent(selectedFilesForRemove, currentMeeting.id));
    }
    const checkedItem = selectedFiles.filter(c => c.checked);
    let allChecked = false;
    if (checkedItem.length === selectedFiles.length) {
        allChecked = true;
    }
    const selectAllFiles = () => {
        if (selectRecommendedStory > 0 || selectedBookmarkId > 0) {
            dispatch(selectAllRecommendationItems(!allChecked))
        }
    }
    const selectedCheckedFiles = selectedFiles.filter(c => c.checked);
    const addToPersentation = () => {
        if (!adding) {
            dispatch(addFilesToMeeting(currentMeeting.id, selectedCheckedFiles.map(row => {
                return {
                    fileId: row.id,
                    storyId: row.storyId
                }
            })));
        }

    };
    const signOut = () => {
        localStorage.clear();
        localStorage.setItem("forceLogout", "true");
        history.push("/login");

    }
    const newItems = selectedFiles.filter(file => {
        return !currentMeeting.meetingContents.find(c => c.fileId === file.id);
    }).filter(c => c.checked);
    const isAllAdded = selectedFiles.filter(file => {
        return currentMeeting.meetingContents.find(c => c.fileId === file.id);
    }).length === selectedFiles.length;

    const renderMobile = () => {
        return (
            <Flex className={styles.header} gap="gap.small">
                {isShareVisible && <FlexItem>
                    <Button disabled={isShareEnabled} onClick={onShareclick} icon={<ShareGenericIcon />} primary />
                </FlexItem>}
                {selectedFilesForRemove.length > 0 && <FlexItem>
                    <Button disabled={removing} text onClick={removeSelectedFiles} icon={<TrashCanIcon />} />
                </FlexItem>}
                {newItems.length > 0 && <FlexItem>
                    <Button disabled={adding} text onClick={addToPersentation} icon={<AddIcon />} content={adding ? 'Adding..' : 'Add'} />
                </FlexItem>}
                {(selectRecommendedStory > 0 || selectedBookmarkId > 0) && !isAllAdded && selectedFiles.length > 1 && <FlexItem>
                    <Button className={allChecked ? 'actionchecked' : ''} text onClick={selectAllFiles} icon={<Check checked={allChecked} />} content='All' />
                </FlexItem>}
                <FlexItem push>
                    <Button className={styles.singOut} text size="medium" onClick={signOut} content="Sign out" />
                </FlexItem>
                <FlexItem push>
                    <Button size="medium" onClick={onAddFileClick} icon={<SearchIcon size="smaller" />} primary />
                </FlexItem>
            </Flex>
        )
    };


    const renderDesktop = () => {
        return (
            <Flex className={styles.header} gap="gap.small">
                {isShareVisible && <FlexItem>
                    <Button disabled={isShareEnabled} onClick={onShareclick} icon={<ShareGenericIcon />} text content="Share selected file(s)" primary />
                </FlexItem>}
                {selectedFilesForRemove.length > 0 && <FlexItem>
                    <Button disabled={removing} text onClick={removeSelectedFiles} icon={<TrashCanIcon />} content='Remove Files' />
                </FlexItem>}
                {newItems.length > 0 && <FlexItem>
                    <Button disabled={adding} text onClick={addToPersentation} icon={<AddIcon />} content={adding ? 'Adding....' : 'Add to My Presentation'} />
                </FlexItem>}
                {(selectRecommendedStory > 0 || selectedBookmarkId > 0) && !isAllAdded && selectedFiles.length > 1 && <FlexItem>
                    <Button className={allChecked ? 'actionchecked' : ''} text onClick={selectAllFiles} icon={<Check checked={allChecked} />} content='Select All Files' />
                </FlexItem>}
                <FlexItem align="center" grow={1}><MessageBox /></FlexItem>
                <FlexItem push>
                    <Button className={styles.singOut} text size="medium" onClick={signOut} content="Sign out" />
                </FlexItem>
                <FlexItem push>
                    <Button size="medium" onClick={onAddFileClick} icon={<SearchIcon size="smaller" />} content="Search" primary />
                </FlexItem>
            </Flex>
        )
    };

    return (
        <>
            {!isMobile && renderDesktop()}
            {isMobile && renderMobile()}
        </>
    );
};
export default Header
